import L from 'leaflet'
import store from '/@/store'
import { getRoot } from '/@/root'
import { ELocalStorageKey, EDeviceTypeName } from '/@/types'
import { getDeviceBySn } from '/@/api/manage'
import { message } from 'ant-design-vue'
import dockIcon from '/@/assets/icons/dock.png'
import rcIcon from '/@/assets/icons/rc.png'
import droneIcon from '/@/assets/icons/drone.png'

export function deviceTsaUpdate () {
  const root = getRoot()

  const iconMap: Record<number, string> = {
    [EDeviceTypeName.Aircraft]: droneIcon,
    [EDeviceTypeName.Gateway]: rcIcon,
    [EDeviceTypeName.Dock]: dockIcon,
  }

  const markers = store.state.markerInfo.coverMap
  const DEFAULT_LNG = 127.5
  const DEFAULT_LAT = 36.5

  function makeLeafletIcon (type: number): L.Icon {
    return L.icon({
      iconUrl: iconMap[type] || droneIcon,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
    })
  }

  function initMarker (type: number, name: string, sn: string, lng?: number, lat?: number) {
    if (markers[sn]) return
    const map: L.Map = root.$map
    if (!map) return

    const marker = L.marker(
      [lat ?? DEFAULT_LAT, lng ?? DEFAULT_LNG],
      { icon: makeLeafletIcon(type), title: name }
    ).addTo(map)

    markers[sn] = marker
  }

  function removeMarker (sn: string) {
    if (!markers[sn]) return
    const map: L.Map = root.$map
    map.removeLayer(markers[sn])
    delete markers[sn]
  }

  function addMarker (sn: string, lng?: number, lat?: number) {
    getDeviceBySn(localStorage.getItem(ELocalStorageKey.WorkspaceId)!, sn)
      .then(data => {
        if (data.code !== 0) {
          message.error(data.message)
          return
        }
        initMarker(data.data.domain, data.data.nickname, sn, lng, lat)
      })
  }

  function moveTo (sn: string, lng: number, lat: number) {
    const marker: L.Marker = markers[sn]
    if (!marker) {
      addMarker(sn, lng, lat)
      return
    }
    // Leaflet에는 MoveAnimation이 없어서 직접 setLatLng으로 이동
    marker.setLatLng([lat, lng])
  }

  return {
    marker: markers,
    initMarker,
    removeMarker,
    moveTo,
  }
}
